import React, { useState, useEffect } from 'react';
import '../styles/Modal.css';

const SuccessModal = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Small delay to allow for the fade-in animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const closeModal = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsOpen(false);
    }, 300); // Match this with the CSS transition duration
  };

  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isVisible ? 'visible' : ''}`} onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={closeModal}>
          &times;
        </button>
        <div className="modal-header">
          <h2>🎉 Technix 7.0 Successfully Completed! 🎉</h2>
        </div>
        <div className="modal-body">
          <p>Thanks to everyone who made Technix 7.0 a grand success!</p>
          <p>Participant's enthusiasm, creativity, and competitive spirit turned every event into an unforgettable experience. We truly appreciate the energy you brought to each competition and the dedication you showed throughout the fest. Special Thanks to all Event Co-ordinators and Volunteers.</p>

          <div className="highlights">
            <ul>
              <li>Massive energy across all competitions - every event was buzzing! ⚡</li>
              <li>Intense battles, close calls, and epic comebacks throughout the fest 💥</li>
              <li>New friendships, fun moments, and memories that will last way beyond Technix 7.0 📸💛</li>
              <li>A whole lot of learning… and even more laughter!</li>
            </ul>
          </div>
          <p>see you all again at <strong>Technix 8.0</strong> for another amazing experience!</p>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
